import { Link, Style } from "@solidjs/meta"
import instrumentSerif from "../assets/fonts/instrument-serif-regular.ttf"
import instrumentSerifItalic from "../assets/fonts/instrument-serif-italic.ttf"
import interRegular from "../assets/fonts/inter-regular.ttf"
import interMedium from "../assets/fonts/inter-medium.ttf"
import interSemibold from "../assets/fonts/inter-semibold.ttf"
import interBold from "../assets/fonts/inter-bold.ttf"
import jetbrainsMonoRegular from "../assets/fonts/jetbrains-mono-regular.ttf"
import jetbrainsMonoMedium from "../assets/fonts/jetbrains-mono-medium.ttf"

export const Font = () => (
  <>
    <Style>{`
      @font-face {
        font-family: "Instrument Serif";
        src: url("${instrumentSerif}") format("truetype");
        font-display: swap;
        font-style: normal;
        font-weight: 400;
      }
      @font-face {
        font-family: "Instrument Serif";
        src: url("${instrumentSerifItalic}") format("truetype");
        font-display: swap;
        font-style: italic;
        font-weight: 400;
      }
      @font-face {
        font-family: "Inter";
        src: url("${interRegular}") format("truetype");
        font-display: swap;
        font-style: normal;
        font-weight: 400;
      }
      @font-face {
        font-family: "Inter";
        src: url("${interMedium}") format("truetype");
        font-display: swap;
        font-style: normal;
        font-weight: 500;
      }
      @font-face {
        font-family: "Inter";
        src: url("${interSemibold}") format("truetype");
        font-display: swap;
        font-style: normal;
        font-weight: 600;
      }
      @font-face {
        font-family: "Inter";
        src: url("${interBold}") format("truetype");
        font-display: swap;
        font-style: normal;
        font-weight: 700;
      }
      @font-face {
        font-family: "JetBrains Mono";
        src: url("${jetbrainsMonoRegular}") format("truetype");
        font-display: swap;
        font-style: normal;
        font-weight: 400;
      }
      @font-face {
        font-family: "JetBrains Mono";
        src: url("${jetbrainsMonoMedium}") format("truetype");
        font-display: swap;
        font-style: normal;
        font-weight: 500;
      }
    `}</Style>
    <Link rel="preload" href={instrumentSerif} as="font" type="font/ttf" crossorigin="anonymous" />
    <Link rel="preload" href={instrumentSerifItalic} as="font" type="font/ttf" crossorigin="anonymous" />
    <Link rel="preload" href={interRegular} as="font" type="font/ttf" crossorigin="anonymous" />
    <Link rel="preload" href={interMedium} as="font" type="font/ttf" crossorigin="anonymous" />
    <Link rel="preload" href={interSemibold} as="font" type="font/ttf" crossorigin="anonymous" />
    <Link rel="preload" href={interBold} as="font" type="font/ttf" crossorigin="anonymous" />
    <Link rel="preload" href={jetbrainsMonoRegular} as="font" type="font/ttf" crossorigin="anonymous" />
    <Link rel="preload" href={jetbrainsMonoMedium} as="font" type="font/ttf" crossorigin="anonymous" />
  </>
)
